import { Config } from '../config';
import { APP_TYPES, EVENT_HANDLER_TYPES } from '../constants';
import { Navigator } from '..';
import { BaseApplication } from './baseApplication';
import { ApplicationLifeCycle } from '../interface';
import { EventHandler } from '../navigator-services';

export class FullScreenApplication extends BaseApplication {

  private iacConnectionTimeout = 0;

  public type: string = APP_TYPES.FULLSCREEN;

  constructor() {
    super();
  }

  // overridden to clear fallback timer
  public setIacConnected(value: boolean): void {
    super.setIacConnected(value);

    if (value && this.iacConnectionTimeout) {
      window.clearTimeout(this.iacConnectionTimeout);
      this.iacConnectionTimeout = 0;
    }
  }

  public open(): void {
    ApplicationLifeCycle.openApplication(this);
    this.initFallback();
  }

  public reinitialize(): void {
    this.resetIacConnected();

    if (this.isRunning()) {
      this.update(() => {
        Navigator.reopenApplication(this.getSysname(), false, 'default');
      }, true);
    }
  }

  public isRunning(): boolean {
    return ApplicationLifeCycle.isApplicationInitialized(this);
  }

  public isOnFocus(): boolean {
    if (this.isRunning()) {
      return ApplicationLifeCycle.isApplicationOnFocus(this);
    }

    return false;
  }

  private initFallback() {
    const fallback = this.config.iac.fallback;

    /* istanbul ignore next else */
    if (fallback && fallback.timeout) {
        this.iacConnectionTimeout = window.setTimeout(() => {
          try {
            this.getFrameReference().setAttribute('src', fallback.url);
            // eslint-disable-next-line no-empty
          } catch (e) { }

          /* istanbul ignore next else */
          if (fallback.connection_fallback_pixel) {
            Navigator.track({
              section: fallback.connection_fallback_pixel,
              modifier: '-,ft',
            });
          }
        }, fallback.timeout);
    }
  }

  private update(onUpdated: () => void, reset: boolean): Promise<void> {
    const sysname = this.getSysname();
    const url = new URL(Config.get().navigator.resolve_app_data_url.replace(/_sysname_/, sysname));
    url.searchParams.set('reset', reset ? 'true' : 'false');
    url.searchParams.set('noCache', Date.now().toString());
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(
        async (res) => {
          if (res.status && res.status === 401) {
            EventHandler.trigger(EVENT_HANDLER_TYPES.KEEPALIVE_FAILED, 401);
            return ;
          }

          const content = await res.json();
          Config.extend({ navigator: content });
          this.updateConfig();

          /* istanbul ignore next else */
          if (typeof (onUpdated) === 'function') {
            onUpdated();
          }
        },
      )
      .catch((reason) => {
        EventHandler.trigger(EVENT_HANDLER_TYPES.KEEPALIVE_FAILED, reason);
      });
  }
}
